import { useMemo, useState } from 'react';

import { filterByQuery, type SearchFields } from '../helpers/criteriaSearch';

export type CriteriaSearchState<T> = {
  query: string;
  setQuery: (value: string) => void;
  results: T[];
  /** True zodra er een niet-lege zoekterm staat; stuurt de keuze van lege staat aan. */
  isSearching: boolean;
};

/**
 * Zoekstate voor een criterialijst. De filterlogica zelf staat in
 * `filterByQuery`; deze hook voegt alleen het invoerveld-state toe.
 *
 * Geef `getName`/`getValues` als functies op moduleniveau mee, niet inline —
 * anders verandert hun referentie elke render en doet de `useMemo` niets.
 */
export function useCriteriaSearch<T>(
  items: readonly T[],
  fields: SearchFields<T>,
): CriteriaSearchState<T> {
  const [query, setQuery] = useState('');
  const { getName, getValues } = fields;

  const results = useMemo(
    () => filterByQuery(items, query, { getName, getValues }),
    [items, query, getName, getValues],
  );

  return { query, setQuery, results, isSearching: query.trim() !== '' };
}
